import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import { gql } from '@yi/core';

import { utilities } from '~/common';

import { FacebookOGTags } from './FacebookOGTags';

const { truncate } = utilities;

type Article = gql.typesSsr.Query_Article_yi_Article;

interface Props {
  title: string;
  seo_title?: string;
  seo_description?: string;
  short_summary: string;
  teacherName: string;
  entry_date: Article['entry_date'];
  entry_type: Article['entry_type'] | 'Live';
  media_duration?: Article['media_duration'];
  url: string;
  image_url: string;
  // landing_page_image: Article['landing_page_image'];
}

export const HelmetTags: React.FC<PropsWithChildren<Props>> = ({
  title,
  seo_title,
  seo_description,
  short_summary,
  teacherName,
  media_duration,
  entry_date,
  entry_type,
  url,
  image_url,
}) => {
  const truncatedShortSummary = truncate(short_summary, 100, '... ');
  const landing_page_image = { processed_url: image_url };

  return (
    <>
      <FacebookOGTags
        url={url}
        title={title}
        image={landing_page_image.processed_url}
        description={short_summary}
      />

      <Helmet>
        <title>{seo_title || title}</title>
        <meta name="description" content={seo_description || short_summary} />

        <link rel="canonical" href={url} />
        {entry_type === 'VIDEO' || entry_type === 'LIVE' ? (
          <script type="application/ld+json">
            {`
            {
              "@context": "http://schema.org",
              "@type": "VideoObject",
              "name": "${title}",
              "description" : "${truncatedShortSummary}",
              "thumbnailUrl": "${landing_page_image.processed_url}",
              "uploadDate": "${entry_date.iso8601}",
              "duration": "${media_duration?.iso8601}"
            }
          `}
          </script>
        ) : (
          <script type="application/ld+json">
            {`
            {
              "@context": "http://schema.org",
              "@type": "Article",
              "mainEntityOfPage":{
                "@type" : "WebPage",
                "@id" : "${url}"
              },
              "headline": "${title}",
              "image": {
                "@type" :  "ImageObject" ,
                "url" : "${landing_page_image.processed_url}",
                "width": 1920,
                "height": 1080
              },
              "datePublished": "${entry_date.iso8601}",
              "dateModified": "${entry_date.iso8601}",
              "author": {
                "@type": "Person" ,
                "name" :  "${teacherName}"
              },
              "publisher" : {
                "@type": "Organization",
                "name": "Yoga International",
                "logo" : {
                  "@type": "ImageObject",
                  "url": "https://images-s3.yogainternational.com/assets/content/site/logo-orange-60.png",
                  "width": 159,
                  "height": 60
                }
              },
              "description": "${truncatedShortSummary}"
            }
          `}
          </script>
        )}
      </Helmet>
    </>
  );
};
